module.exports = __webpack_public_path__ + "static/media/1005992.6acd6428.png";